import https from "https";
import fetch from "node-fetch";

// RPC endpoints for mainnet and testnet
const getRpcEndpoint = (chainId = 101) => {
  const isTestnet = chainId === 103;
  return isTestnet
    ? "https://api.testnet.solana.com"
    : "https://api.mainnet-beta.solana.com";
};

/**
 * Decode a raw Solana transaction using Solana RPC
 */
export const DecodeSolanaRawTx = async (rawTxBase64, chainId = 101) => {
  const rpcEndpoint = getRpcEndpoint(chainId);

  const res = await fetch(rpcEndpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      jsonrpc: "2.0",
      id: 1,
      method: "decodeTransaction",
      params: [rawTxBase64], // make sure it's base64 encoded
    }),
  });

  if (!res.ok) {
    throw new Error("Failed to decode Solana transaction");
  }

  const data = await res.json();

  if (data.error) {
    throw new Error(data.error.message || "Failed to decode transaction");
  }

  return data.result;
};

/**
 * Publish a raw Solana transaction using Solana RPC
 */
export const PublishSolanaRawTx = async (rawTxBase64, chainId = 101) => {
  const rpcEndpoint = getRpcEndpoint(chainId);

  const res = await fetch(rpcEndpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      jsonrpc: "2.0",
      id: 1,
      method: "sendTransaction",
      params: [rawTxBase64],
    }),
  });

  const data = await res.json();
  if (data.error) {
    throw new Error(data.error.message);
  }

  return data.result; // TX ID
};

export const GetSolanaBalance = (address, chainId = 101) => {
  return new Promise((resolve, reject) => {
    const rpcEndpoint = getRpcEndpoint(chainId);

    const data = JSON.stringify({
      jsonrpc: "2.0",
      id: 1,
      method: "getBalance",
      params: [address],
    });

    const url = new URL(rpcEndpoint);
    const options = {
      hostname: url.hostname,
      path: url.pathname,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Content-Length": data.length,
      },
    };

    const req = https.request(options, (res) => {
      let body = "";

      res.on("data", (chunk) => {
        body += chunk;
      });

      res.on("end", () => {
        try {
          const response = JSON.parse(body);
          if (response.result && response.result.value != null) {
            resolve(response.result.value.toString()); // lamports
          } else {
            reject(new Error("Invalid response from Solana RPC"));
          }
        } catch (err) {
          reject(err);
        }
      });
    });

    req.on("error", (e) => {
      reject(e);
    });

    req.write(data);
    req.end();
  });
};
